import { render, staticRenderFns } from "./CMSGlobalSettingForm.vue?vue&type=template&id=3746c9af&"
import script from "./CMSGlobalSettingForm.vue?vue&type=script&lang=js&"
export * from "./CMSGlobalSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports